import BaseAgencyScopeEntityDto from '@/models/Shared/BaseAgencyScopeEntityDto';
import AgencyUserDto from '@/models/AgencyUsers/AgencyUserDto';
import AgencyGroupStatus from '@/models/AgencyGroups/AgencyGroupStatus';

export default class AgencyGroupDto extends BaseAgencyScopeEntityDto {
    name = '';
    status: AgencyGroupStatus = AgencyGroupStatus.Active;
    agencyUsers: AgencyUserDto[] = [];
}